import TicketAvatar from './TicketAvatar'
export default TicketAvatar
